

export function computeNodeId(type, value) {
  // using urlencoding to concatenate unambiguously, regarding the type and value content
  return encodeURIComponent(type) + '+' + encodeURIComponent(value);
}

export function computeEdgeId(from_node_id, to_node_id) {
  return from_node_id + '&' + to_node_id; // node ids are already urlencoded with a + between type and value
}

export const isObject = (object) => {
  return object != null && typeof object === "object";
};

export function isDeepEqual(object1, object2) {
  const objKeys1 = Object.keys(object1);
  const objKeys2 = Object.keys(object2);

  if (objKeys1.length !== objKeys2.length) return false;

  for (var key of objKeys1) {
    const value1 = object1[key];
    const value2 = object2[key];

    const isObjects = isObject(value1) && isObject(value2);

    if ((isObjects && !isDeepEqual(value1, value2)) ||
      (!isObjects && value1 !== value2)
    ) {
      return false;
    }
  }
  return true;
};

export function warn(msg) {
  console.warn(msg);
}
